"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactQuery = require("react-query");
var _core = require("@folio/stripes/core");
var _utils = require("../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useCustomProperties = _ref => {
  let {
    endpoint,
    ctx,
    nsValues = {
      sort: 'id'
    },
    options = {},
    queryParams,
    returnQueryObject = false
  } = _ref;
  const ky = (0, _core.useOkapiKy)();
  const custPropOptions = {
    searchKey: 'label,name,description',
    filterKeys: {
      ContextKey: 'ctx'
    },
    sort: [{
      path: 'weight'
    }, {
      path: 'label'
    }],
    filters: [],
    stats: false,
    max: 100,
    ...options
  };
  if (Array.isArray(ctx)) {
    // If we have an array, append a context filter for each ctx given

    // Special case if one is isNull
    custPropOptions.filters.push({
      values: ctx.map(c => c === 'isNull' ? 'ctx isNull' : `ctx==${c}`)
    });
  } else if (ctx === 'isNull') {
    // isNull is a special case
    custPropOptions.filters.push({
      value: 'ctx isNull'
    });
  } else if (ctx) {
    custPropOptions.filters.push({
      path: 'ctx',
      value: ctx
    });
  }
  const query = (0, _utils.generateKiwtQuery)(custPropOptions, nsValues);
  const path = `${endpoint}${query}`;
  const queryObject = (0, _reactQuery.useQuery)(['stripes-kint-components', 'useCustomProperties', 'custprops', ctx, path], () => ky(path).json(), queryParams);
  if (returnQueryObject) {
    return queryObject || {};
  }
  const {
    data: custprops
  } = queryObject;
  return custprops || [];
};
useCustomProperties.propTypes = {
  endpoint: _propTypes.default.string,
  ctx: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
  queryParams: _propTypes.default.object,
  returnQueryObject: _propTypes.default.bool
};
var _default = exports.default = useCustomProperties;